import React from "react";

import sample from "lodash/sample";

import styles from "./LoadingMessage.scss";

const messages = [
  "Setting the table...",
  "Chopping the onions...",
  "Polishing the silverware...",
  "Adding a pinch of salt...",
  "Folding the napkins...",
  "Preheating the oven...",
  "Tying on the apron...",
  "Boiling the water...",
];

const LoadingMessage = (): JSX.Element => {
  const loadingMessage = sample(messages);

  return <div className={styles.loadingMessage}>{loadingMessage}</div>;
};

export default LoadingMessage;
